import { AxiosResponse } from "axios";
import axios from "../../../lib/axios";
import { API_ENDPOINTS } from "../../../constants/api_endpoints";
import { IPagePayload, PageType } from "../../../types/api/allPages";
import { TResponse } from "../../../types/common";

// Send pageType in URL params
export async function  savePage(
  pageType: PageType,
  data: IPagePayload
): Promise<AxiosResponse<TResponse<IPagePayload>>> {
  return axios.post<TResponse<IPagePayload>>(
    `${API_ENDPOINTS.ALL_PAGE_SAVE}/${pageType}`,
    data
  );
}

export async function detailPage(
  pageType: PageType
): Promise<AxiosResponse<TResponse<IPagePayload>>> {
  return axios.get<TResponse<IPagePayload>>(
    `${API_ENDPOINTS.ALL_PAGE_DETAIL}/${pageType}`
  );
}